const ButtonStyle = {
  Default: '_default',
  DefaultBorder: 'defaultBorder',
  Icon: 'iconButton',
  NoBackground: 'noBackground',
  Login: 'login',
  Submit: 'submit',
  Cancel: 'cancel',
  Popup: 'popup',
  PopupContext: 'popupContext',
  Header: 'header',
  HeaderLogo: 'headerLogo',
};

export default ButtonStyle;
